export default class DeviceRegistry {
	private static handlers = new Map<string, (dataObject: KioDeviceDataList) => void>();

	static register(deviceName: string, handler: (dataObject: KioDeviceDataList) => void) {
		this.handlers.set(deviceName, handler);
		// Attach to window only once
		if (window.OnKioDeviceData === undefined) {
			window.OnKioDeviceData = (name: string, data: KioDeviceDataList) => {
				this.handlers.get(name)?.(data);
			};
		}
	}

	static unregister(deviceName: string) {
		console.log('[DeviceRegistry] unregister called for:', deviceName, 'remaining handlers:', this.handlers.size - 1);
		this.handlers.delete(deviceName);
		if (this.handlers.size === 0) {
			console.log('[DeviceRegistry] no handlers left, removing window.OnKioDeviceData');
			delete window.OnKioDeviceData;
		}
	}
}
